import { clsx } from "clsx";

export const fmtDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  const p = (n) => String(n).padStart(2, "0");
  return `${p(d.getDate())}.${p(d.getMonth() + 1)}.${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}`;
};

export const fmtMoney = (v, currency = "PLN") => {
  if (v == null) return "—";
  const s = Number(v).toLocaleString("pl-PL", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return `${s} ${currency === "PLN" ? "zł" : currency}`;
};

export const fmtNum = (v) => (v == null ? "—" : Number(v).toLocaleString("pl-PL"));

export const Trend = ({ value }) => {
  if (value == null) return <span className="text-xs text-brand-muted">—</span>;
  const up = value >= 0;
  return (
    <span className={clsx("text-xs font-semibold", up ? "text-brand-accent" : "text-red-400")}>
      {up ? "+" : ""}
      {value}%
    </span>
  );
};

const STATUS_COLORS = {
  OPŁACONE: "bg-brand-accent/15 text-brand-accent",
  WYKONANE: "bg-emerald-500/15 text-emerald-300",
  ZWROT: "bg-amber-500/15 text-amber-300",
  KOREKTA: "bg-sky-500/15 text-sky-300",
  BONUS: "bg-fuchsia-500/15 text-fuchsia-300",
  paid: "bg-brand-accent/15 text-brand-accent",
  settled: "bg-emerald-500/15 text-emerald-300",
  NOWA: "bg-brand-accent/15 text-brand-accent",
  W_TOKU: "bg-amber-500/15 text-amber-300",
  ZAMKNIETA: "bg-brand-elevated text-brand-muted",
  ACTIVE: "bg-emerald-500/15 text-emerald-300",
  BLOCKED: "bg-red-500/15 text-red-300",
  DELETED: "bg-red-500/25 text-red-200",
  failed: "bg-red-500/15 text-red-300",
  amount_mismatch: "bg-red-500/15 text-red-300",
  expired: "bg-brand-elevated text-brand-muted",
};

export const StatusPill = ({ status, label }) => (
  <span
    className={clsx(
      "inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-bold uppercase tracking-wide",
      STATUS_COLORS[status] || "bg-brand-elevated text-brand-sec",
    )}
  >
    {label || status}
  </span>
);

export const Panel = ({ title, action, children, className, testId }) => (
  <section
    data-testid={testId}
    className={clsx("rounded-panel border border-brand-line bg-brand-surface p-5 md:p-6", className)}
  >
    {(title || action) && (
      <div className="mb-4 flex items-center justify-between gap-3">
        {title && <h2 className="font-display text-base font-bold text-brand-text">{title}</h2>}
        {action}
      </div>
    )}
    {children}
  </section>
);

export const PageHeader = ({ title, subtitle, action }) => (
  <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
    <div>
      <h1 className="font-display text-2xl font-bold tracking-tight text-brand-text">{title}</h1>
      {subtitle && <p className="mt-1 text-sm text-brand-sec">{subtitle}</p>}
    </div>
    {action}
  </div>
);

export const Th = ({ children, className }) => (
  <th className={clsx("px-3 py-2.5 text-left text-[11px] font-bold uppercase tracking-wide text-brand-muted", className)}>
    {children}
  </th>
);

export const Td = ({ children, className }) => (
  <td className={clsx("px-3 py-3 text-sm text-brand-text", className)}>{children}</td>
);

export const Empty = ({ children }) => (
  <div className="py-12 text-center text-sm text-brand-muted">{children}</div>
);
